/**
 * @file ConsentDiffLine.tsx
 * @description Строка «Отличия от ред. N: K полей [Показать]» под
 * предпросмотром (phase19.16, Р3г; uiux-r3g-consent-texts §3): кнопка
 * включает подсветку изменённых полей в форме.
 */

import { fieldsWord } from "../../../lib/platform/consent-texts-format";
import { Button } from "../../ui/button";

interface Props {
  baseNumber: number;
  count: number;
  shown: boolean;
  onToggle: () => void;
}

export function ConsentDiffLine({ baseNumber, count, shown, onToggle }: Props) {
  if (count === 0) return <p className="type-caption m-0 text-on-surface-variant">Без отличий от ред. {baseNumber}</p>;
  return (
    <div className="flex flex-wrap items-center gap-x-3">
      <span className="type-body text-on-surface">
        Отличия от ред. {baseNumber}: {fieldsWord(count)}
      </span>
      <Button variant="ghost" className="min-h-12" aria-pressed={shown} onClick={onToggle}>
        {shown ? "Скрыть подсветку" : "Показать"}
      </Button>
    </div>
  );
}
